<template>
  <div id="app">
    <el-row class="step1" v-show="currentStep.key === steps[0].key">
      <div style="color:red; font-size: 16px; font-weight: bold;">Please select Data Extension before setting up SMS</div>
      <el-col :span="14">
        <el-row>
          <ContentForm ref="form" :textAreaMax="textAreaMax" :previewLength="previewLength" :splitsNum="splitsNum" v-model="step1Config"></ContentForm>
        </el-row>
        <el-row>
          <div class="input-group">
            Campaign Type<span style="color: red">*</span>
            <el-select style="width: 100%" v-model="campaignType" placeholder="Please Select">
              <el-option
                v-for="item in campaignTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="input-group">
            Campaign Code<span style="color: red">*</span>
            <el-input
              placeholder="Please enter Campaign code"
              v-model="campaignCode"
              resize="none"
            ></el-input>
          </div>
          <div class="input-group">
            Activity Name<span style="color: red">*</span>
            <el-input
              placeholder="Please enter Activity Name"
              v-model="activityName"
              resize="none"
            ></el-input>
          </div>
          <div class="input-group">
            ICES Remark<span style="color: red">*</span>
            <el-input
              placeholder="Please enter ICES Remark"
              v-model="remark"
              resize="none"
            ></el-input>
          </div>
        </el-row>
      </el-col>
      <el-col :span="6">
        <Preview :msg="previewText" :breakPoint="messageBreakPiont[lang]"></Preview>
      </el-col>
    </el-row>
    <el-row class="step2" v-show="currentStep.key === steps[1].key">
      <el-col :span="12">
        <div class="configure-blackout">
          <div class="header">
            <span class="configure-send-blackout-window-text">Configure Send Blackout Window</span>
          </div>
          <div class="blackout-content">
            <el-radio-group v-model="blackoutType">
              <!-- <el-radio :label="NO_BLACKOUT">Do not use send blackout window</el-radio>\ -->
              <!-- <div class="radio-group-content">
                <span class="no-blackout-label no-blackout-content-text">Send a message at any time.</span>
              </div> -->
              <el-radio :label="EXISTING_BLACKOUT">Use existing MobileConnect blackout window</el-radio>
              <div class="radio-group-content">
                <span
                  class="no-blackout-label no-blackout-content-text"
                >(only send within 10:00-22:00)</span>
              </div>
              <el-radio :label="CUSTOM_BLACKOUT">Use custom settings for this message</el-radio>
              <div class="radio-group-content">
                <span
                  class="no-blackout-label no-blackout-content-text"
                >(only send within From-To)</span>
              </div>
              <div class="time-select-container">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <p style="font-size: 14px">From</p>
                  </el-col>
                  <el-col :span="12">
                    <p style="font-size: 14px">to</p>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-time-select
                      :disabled="blackoutType !== CUSTOM_BLACKOUT"
                      placeholder="Start time"
                      v-model="startTime"
                      :picker-options="{
                    start: '08:00',
                    step: '01:00',
                    end: '22:00',
                    maxTime: endTime
                  }"
                    ></el-time-select>
                  </el-col>
                  <el-col :span="12">
                    <el-time-select
                      :disabled="blackoutType !== CUSTOM_BLACKOUT"
                      placeholder="End time"
                      v-model="endTime"
                      :picker-options="{
                    start: '08:00',
                    step: '01:00',
                    end: '22:00',
                    minTime: startTime
                  }"
                    ></el-time-select>
                  </el-col>
                </el-row>
              </div>
            </el-radio-group>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="step3" v-show="currentStep.key === steps[2].key">
      <el-col :span="12">
        <div class="configure-sms-channel">
          <div class="header">
            <div class="configure-send-blackout-window-text">Configure Send SMS Channel</div>
          </div>
          <div class="settings-radio-group">
            <el-radio-group v-model="computedChannel">
              <div v-for="item in this.channelList" :key="item.value" style="display: block;">
                <el-radio
                  :label="item.value"
                  style="margin: 8px 10px"
                >{{`${item.name} (${item.value})`}}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="configure-target-date">
          <div class="header">
            <span class="configure-send-blackout-window-text">Target send date</span>
          </div>
          <el-row>
            <el-date-picker
              v-model="targetDate"
              type="datetime"
              placeholder="Select date and time"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row class="step4" v-show="currentStep.key === steps[3].key" :gutter="20">
      <el-col :span="12" class="activity-summary">
        <Summary :message="msg"
          :previewChannel="previewChannel"
          :targetDate="targetDate"
          :blackoutType="blackoutType"
          :isEnableShorten="isEnableShorten"
          :notification="notification"></Summary>
      </el-col>
      <el-col :span="12" class="summary-preview">
        <preview :msg="previewText" :breakPoint="messageBreakPiont[lang]"></preview>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Preview from "./components/Preview.vue";
import ContentForm from "./components/ContentForm.vue";
import Summary from "./components/Summary.vue";
// import replacePlaceHolder from "./utils/replacePlaceHolder.js";
import Postmonger from "postmonger";
import isChsMsg from "./utils/isChsMsg.js";
import axios from "axios";
import _ from 'lodash'
import { ShortenUrlDelimiterRegexp, ShortenUrlLookupRegexp} from "./utils/RegexpHelper"

export default {
  name: "app",
  components: {
    Preview,
    ContentForm,
    Summary
  },
  data() {
    return {
      connection: null,
      payload: {},
      schema: [],
      isSchemaLoaded: false,
      startTime: "12:00",
      endTime: "12:00",
      // NO_BLACKOUT: "0",
      EXISTING_BLACKOUT: "1",
      CUSTOM_BLACKOUT: "2",
      blackoutType: "1",
      steps: [
        // initialize to the same value as what's set in config.json for consistency
        { label: "Step 1", key: "step1" },
        { label: "Step 2", key: "step2" },
        { label: "Step 3", key: "step3" },
        { label: "Step 4", key: "step4" }
      ],
      // steps[0].key
      currentStep: { label: "Step 1", key: "step1" },
      channelList: [],
      channel: "",
      isFetchChannel: false,
      targetDate: "",
      messageBreakPiont: {
        eng: [160, 306, 459],
        chi: [70, 126, 189]
      },
      msg: "",
      campaignCode: '',
      activityName: '',
      remark: '',
      isEnableShorten: true,
      otp: {
        url: '',
        pps: '',
        expiredDate: '',
        flag: false,
        qs: ''
      },
      step1Error: false,
      notification: 'no-set',
      campaignType: "",
      campaignTypeOptions: [{
          value: '3rd_Party_Promo_SMS_Flag',
          label: '3rd Party Promotion'
        }, {
          value: 'HKBN_Promo_SMS_Flag',
          label: 'HKBN Promotion'
        }, {
          value: 'Notification_SMS_Flag',
          label: 'Notification'
        }, {
          value: 'Survey_SMS_Flag',
          label: 'Survey'
        }, {
          value: 'Override_Opt_In_Rules_SMS_Flag',
          label: 'Override Opt-In Rules'
        }],
    };
  },
  computed: {
    step1Config: {
      get: function () {
        return {
          message: this.msg,
          isEnableShorten: this.isEnableShorten,
          otp: this.otp,
          step1Error: this.step1Error
        }
      },
      // setter
      set: function (newValue) {
        const {message, isEnableShorten, otp, isError} = newValue
        this.msg = message
        this.isEnableShorten = isEnableShorten
        this.otp = otp
        this.step1Error = isError
      },
    },
    computedChannel: {
      get: function() {
        return this.channel
      },
      set: function (value) {
        this.channel = value
        const channelData = this.channelList.find(channel => channel.value === value)
        if (channelData) {
          this.notification = channelData.notification
        }
      }
    },
    textAreaMax() {
      return this.messageBreakPiont[this.lang][
        this.messageBreakPiont[this.lang].length - 1
      ];
    },
    previewText() {
      return this.msg
      // return replacePlaceHolder(this.msg, "738883500");
    },
    previewLength() {
      return this.isEnableShorten ? this.msg.replace(/%%LINK%%/ig, ''.padStart(18, '0')).replace(/<<\[\[LINK\]\]>>/ig, ''.padStart(18, '0')).replace(/http[s]?:\/\/[^(\s)]*/ig, ''.padStart(18, '0')).length : this.msg.length
      // return replacePlaceHolder(this.msg, "738883500").length; 
    },
    lang() {
      return isChsMsg(this.msg) ? "chi" : "eng";
    },
    previewChannel() {
      for (var i = 0; i < this.channelList.length; i++) {
        if (this.channel === this.channelList[i].value) {
          return this.channelList[i]
        }
      }
      return {value: this.channel, name: ''}
    },
    splitsNum() {
      var num = 0
      for (; num < this.messageBreakPiont[this.lang].length; num++) {
        if (this.messageBreakPiont[this.lang][num] >= this.previewLength) {
          break;
        }
      }
      return num + 1
    }
  },
  watch: {
    msg: function() {
      if(this.currentStep.key === this.steps[0].key) {
        var isEnable =  (this.msg && this.msg.length > 0) 
          && (this.activityName && this.activityName.length > 0) 
          && (this.campaignCode && this.campaignCode.length > 0) 
          && (this.remark && this.remark.length > 0)
          && (this.campaignType && this.campaignTypeOptions.some(option => option.value === this.campaignType))
        this.connection.trigger('updateButton', { button: 'next', enabled: isEnable});
      }
    }
  },
  mounted() {

    this.connection = new Postmonger.Session();
    this.connection.on("initActivity", this.initialize);
    this.connection.on("clickedNext", this.onClickedNext);
    this.connection.on("clickedBack", this.onClickedBack);
    this.connection.on("gotoStep", this.onGotoStep);
    this.connection.on("requestedSchema", this.requestedSchema);
    this.connection.trigger("ready");
    this.connection.trigger("requestSchema");
    this.isFetchChannel = true;
  },
  methods: {
    async getChannelList(execute_url) {
      var url = window.appPath + `data/channel.json?ts=${new Date().valueOf()}`
      if (execute_url.includes('/es-activity/')) {
        url = window.appPath + 'data/es_channel.json?ts=${new Date().valueOf()}'
      }
      return axios({
        method: "get",
        url: url
      }).then(response => {
        this.channelList = response.data.channels;
        this.isFetchChannel = false;
        this.connection.trigger("ready");
      }).catch(err => {
        throw err
      });
    },
    async initialize(data) {
      if (data) {
        this.payload = data;
      }
      await this.getChannelList(_.get(data, 'arguments.execute.url', ''))
      var hasInArguments = Boolean(
        this.payload["arguments"] &&
          this.payload["arguments"].execute &&
          this.payload["arguments"].execute.inArguments &&
          this.payload["arguments"].execute.inArguments.length > 0
      );

      var inArguments = hasInArguments
        ? this.payload["arguments"].execute.inArguments
        : [];

      inArguments.forEach((inArgument) => {
        for (var key in inArgument) {
          var val = inArgument[key]
          switch (key) {
            case "message":
              this.msg = val;
              break;

            case "channel":
              if (!this.channel) {
                this.channel = val;
              }
              this.channelList.forEach((obj) => {
                if (val === obj.value) {
                  this.channel = val;
                }
              });
              break;
            // case "startTime":
            //   this.startTime = val;
            //   break;
            // case "endTime":
            //   this.endTime = val;
            //   break;
            // case "blackoutType":
            //   this.blackoutType = val;
            //   break;
            // case "targetDate":
            //   this.targetDate = val;
            //   break;
            case "schema":
              break;
            default:
              this[key] = val
              break;
          }
        }
      });

      // If there is no message selected, disable the next button
      // if (this.otp.flag) {
      //   return
      // } else if (!this.msg) {
      //   this.showStep(null, 1);
      //   this.connection.trigger("updateButton", {
      //     button: "next",
      //     enabled: false
      //   });
      //   // If there is a message, skip to the summary step
      // } else {
      //   if (this.blackoutType !== "2" || !this.startTime || !this.endTime) {
      //     this.showStep(null, 2);
      //   } else if (!this.targetDate || !this.channel) {
      //     this.showStep(null, 3);
      //   } else {
      //     this.showStep(null, 4);
      //   }
      // }
    },
    async onClickedNext() {
      if (this.currentStep.key === this.steps[0].key) {
        if (!await this.$refs['form'].validate()) {
          this.connection.trigger("ready");
          return
        }
      }
      if (this.currentStep.key === this.steps[2].key) {
        if (this.isFetchChannel || !this.channel) {
          return
        }
        this.connection.trigger("nextStep");
      } else if (this.currentStep.key === this.steps[this.steps.length - 1].key) {
        this.save();
      } else {
        this.connection.trigger("nextStep");
      }
      window.scroll(0, 0);
    },
    onClickedBack() {
      this.connection.trigger("prevStep");
      window.scroll(0, 0);
    },
    async onGotoStep(step) {
      if (this.currentStep.key === this.steps[0].key) {
        if (!await this.$refs['form'].validate()) {
          this.connection.trigger("ready");
          return
        }

        if (this.campaignType.length == 0) {
          alert("please select campaign type")
          this.connection.trigger("ready");
          return
        }
        if (this.campaignCode.length == 0) {
          alert("please enter campaign code")
          this.connection.trigger("ready");
          return
        }
        if (this.activityName.length == 0) {
          alert("please enter activity name")
          this.connection.trigger("ready");
          return
        }
        if (this.remark.length == 0) {
          alert("please enter remark")
          this.connection.trigger("ready");
          return
        }
      }
      this.showStep(step);
      if (step.key === this.steps[2].key) {
        if (!this.isFetchChannel && this.channel) {
          this.connection.trigger("ready");
        }
      } else {
        this.connection.trigger("ready");
      }
    },
    showStep(step, stepIndex) {
      if (stepIndex && !step) {
        step = this.steps[stepIndex - 1];
      }

      for (var i = 1; i < stepIndex; i++) {
        this.connection.trigger("nextStep");
      }

      this.currentStep = step;

      switch (this.currentStep.key) {
        case "step1":
          // $("#step1").show();
          this.connection.trigger("updateButton", {
            button: "next",
            enabled: Boolean(this.msg)
          });
          this.connection.trigger("updateButton", {
            button: "back",
            visible: false
          });
          break;
        case "step2":
          // $("#step2").show();
          this.connection.trigger("updateButton", {
            button: "back",
            visible: true
          });
          this.connection.trigger("updateButton", {
            button: "next",
            text: "next",
            visible: true
          });
          break;
        case "step3":
          // $("#step3").show();
          this.connection.trigger("updateButton", {
            button: "back",
            visible: true
          });
          this.connection.trigger("updateButton", {
            button: "next",
            text: "next",
            visible: true
          });
          break;
        case "step4":
          // $("#step4").show();
          this.connection.trigger("updateButton", {
            button: "next",
            text: "done",
            visible: true
          });
          break;
      }
    },
    requestedSchema(data) {
      this.isSchemaLoaded = true;
      // eslint-disable-next-line
      console.log(data["schema"])
      this.schema = data["schema"];
    },
    save() {
      if (!this.isSchemaLoaded) {
        alert("please wait the DE schema loaded.");
      } else {
        try {
          var name = this.msg.substring(
            0,
            this.msg.length < 10 ? this.msg.length : 10
          );

          // 'payload' is initialized on 'initActivity' above.
          // Journey Builder sends an initial payload with defaults
          // set by this activity's config.json file.  Any property
          // may be overridden as desired.
          this.payload.name = name;

          var data = this.convertSchema2Data();
          var schemaKeys = Object.keys(data)
          var schemaValues = schemaKeys.map(v => data[v])

          if (this.isEnableShorten) {
            this.msg = this.msg.split(ShortenUrlDelimiterRegexp).map(text => {
              if (!ShortenUrlLookupRegexp.test(text)) {
                return text
              } else {
                // replace <<CONTENT>> to CONTENT, add space after content in order to delimit URL and message
                text = text.replace(
                  ShortenUrlLookupRegexp,
                  function ($0, $1) {
                    return $1;
                  }
                );
                text = text.replace(/http[s]?:\/\/[^(\s)]*/g, (matched) => {
                  // reverse %% to %25%25, normal URL won't exist "%%".
                  matched = matched.replace(/%%([\w_-]*)%%/ig, function($0, $1) {
                    return `%25%25${$1}%25%25`
                  })
                  let parsed = new URL(matched)

                  parsed.searchParams.set('utm_source', 'sfmc')
                  parsed.searchParams.set('utm_medium', 'sms')
                  parsed.searchParams.set('utm_campaign', `${this.activityName}_%%sendOutDate%%`)
                  parsed.searchParams.set('utm_pps', '%%PPS%%')
                  
                  return parsed.toString().replace(/%25%25([\w_-]*)%25%25/ig, function($0, $1) {
                    return `%%${$1}%%`
                  })
                })
                return `<<${text}>>`
              }
            }).join('')
          }

          const channelData = this.channelList.find(channel => channel.value === this.channel)
          let _notification
          if (channelData) {
            _notification = channelData.notification
          }

          this.payload["arguments"].execute.inArguments = [
            Object.assign({}, {
              schemaKeys,
              schemaValues
            }, {
              message: this.msg,
              campaignType: this.campaignType,
              campaignCode: this.campaignCode,
              activityName: this.activityName,
              remark: this.remark,
              // phone: data["phone"],
              otp: this.otp,
              blackoutType: this.blackoutType,
              startTime: this.startTime,
              endTime: this.endTime,
              channel: this.channel,
              targetDate: this.targetDate,
              isEnableShorten: this.isEnableShorten,
              notification: _notification ? _notification : this.notification
            })
          ];

          // if (data['PPS']) {
          //   this.payload["arguments"].execute.inArguments[0]['PPS'] = data['PPS']
          // }

          var matches = this.msg.match(/%%([^%]+)%%/ig)
          var errorExp = []
          var errorFlag = false
          matches && matches.filter(el => el==='sendOutDate').forEach(val => {
            val = val.replace(/%/ig, '')
            if (!schemaKeys.some(key => new RegExp(`^${val}$`, 'ig').test(key) && data[key])) {
              errorFlag = true
              errorExp.push('%%' + val +'%%')
            }
          })
          if (errorFlag) {
            this.payload["metaData"].isConfigured = false;
            this.connection.trigger("updateActivity", this.payload);
            alert(
              "expression error, [" + errorExp.join(', ') + "] seems doesn't exist in current DE"
            );
            return
          }

          if (!data.phone) {
            this.payload["metaData"].isConfigured = false;
            this.connection.trigger("updateActivity", this.payload);
            alert(
              "error: cannot found a Phone field in data extension, please try again"
            );
          } else {
            this.payload["metaData"].isConfigured = true;
            this.connection.trigger("updateActivity", this.payload);
          }
        } catch (ex) {
          this.payload["metaData"].isConfigured = false;
          this.connection.trigger("updateActivity", this.payload);
          alert(`error, please reload the activity. ${ex.message}`);
        }
      }
    },
    convertSchema2Data() {
      var data = {};
      for (var el of this.schema) {
        if (el.key) {
          if (!el.key.includes('Event')) {
            continue
          }
          if (el.type === "Phone" && !data["Phone"]) {
            data["phone"] = `{{${el.key}}}`;
            continue;
          }
          data[el.key.split(".").pop()] = `{{${el.key}}}`;
        }
      }
      Object.assign(data, {
        "3rd_Party_Promo_SMS_Flag": "{{Contact.Attribute.HKBN_Customer_Prod.3rd_Party_Promo_SMS_Flag}}",
        "HKBN_Promo_SMS_Flag": "{{Contact.Attribute.HKBN_Customer_Prod.HKBN_Promo_SMS_Flag}}",
        "Notification_SMS_Flag": "{{Contact.Attribute.HKBN_Customer_Prod.Notification_SMS_Flag}}",
        "Survey_SMS_Flag": "{{Contact.Attribute.HKBN_Customer_Prod.Survey_SMS_Flag}}",
        // "Override_Opt_In_Rules_SMS_Flag": "{{Contact.Attribute.HKBN_Customer_Prod.Override_Opt_In_Rules_SMS_Flag}}",
      })
      return data;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.input-group {
  margin: 20px 0;
}

.configure-blackout .header,
.configure-sms-channel .header,
.configure-sms-channel,
.configure-target-date .header,
.activity-summary .header {
  margin-bottom: 20px;
}
.configure-blackout .el-radio {
  font-size: 16px;
}
.radio-group-content {
  font-size: 14px;
  margin-bottom: 10px;
  color: #54698d;
  padding-left: 24px;
}
.time-select-container {
  padding-top: 10px;
}
.subscriber-opt-in-message {
  word-break: break-word;
}
.activity-summary .el-col {
  margin-bottom: 20px;
}
.data-label {
  text-transform: uppercase;
  font-size: 12px;
  margin-bottom: 2px;
  text-shadow: 0 1px #fff;
  color: #75819d;
}
</style>
